import { OnSaleEventPageContentMapAndMetricsWrapper } from 'src/navigations/Routes/OnSaleEvent/OnSaleEventPage';

export const InventoryEventDiscoverySection = ({
  eventId,
}: {
  eventId: number;
}) => {
  return (
    <OnSaleEventPageContentMapAndMetricsWrapper tabView eventId={eventId} />
  );
};
